import { useState, useContext, useEffect } from "react";
import { Box, Button, List, SwipeableDrawer } from "@mui/material";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import CloseIcon from "@mui/icons-material/Close";
import NavButton from "../Navbar/NavButton";
import { PREMIUM_PAGES, NAVBAR_OPTIONS } from "../../../constants/index";
import { GlobalContext } from "../Context";
import { useTranslation } from "react-i18next";
import PlayerCard from "../Navbar/PlayerCard/PlayerCard";
import { background, white } from "../../../theme/colours";

const MobileNavBar = () => {
  const { t } = useTranslation("Navigation");
  const {
    tabletView,
    mobileView,
    optionState,
    setOptionState,
    currentUser,
    userState,
  } = useContext(GlobalContext);

  const navBarListStyle = {
    backgroundColor: background.primary,
    pt: "5rem",
    width: "20rem",
    overflow: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  };

  const hamburgerIconStyle = {
    color: white,
  };

  const navBtnStyle = {
    width: "20%",
    ml: !mobileView && "2rem",
    mb: tabletView && "1rem",
  };

  const [showNavBar, setShowNavBar] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowNavBar(open);
  };

  const handleNavClick = (type) => {
    setShowNavBar(false);
    setOptionState({ nav: type, page: "main" });
  };

  useEffect(() => {
    // Prevents page scrolling when the mobile nav is open
    const html = document.querySelector("html");
    html && (html.style.overflowY = showNavBar ? "hidden" : "auto");
    return () => {
      const html = document.querySelector("html");
      html && (html.style.overflowY = "auto");
    };
  }, [showNavBar]);

  const renderNavButton = (option) => {
    const freeUser = !currentUser.isAdmin && !currentUser.isViewer;
    const text =
      option.name === "campaign"
        ? userState.isAdmin
          ? t("campaigns")
          : t("challenges")
        : option.name === "competitionInfo"
        ? t("challenges")
        : t(option.name);

    if (freeUser && PREMIUM_PAGES.find((page) => page === option.name)) {
      return null;
    }

    return (
      <NavButton
        key={`Mobile-NavBar-${option.name}`}
        name={option.name}
        text={text}
        activeButton={optionState.nav}
        handleClick={handleNavClick}
        icon={option.icon}
      />
    );
  };

  const renderNavBarOptions = () => (
    <Box sx={navBarListStyle} role="presentation">
      <PlayerCard />
      <List>{NAVBAR_OPTIONS.map(renderNavButton)}</List>
    </Box>
  );

  return (
    <Box>
      {showNavBar ? (
        <Button onClick={toggleDrawer(false)} sx={navBtnStyle}>
          <CloseIcon sx={hamburgerIconStyle} />
        </Button>
      ) : (
        <Button onClick={toggleDrawer(true)} sx={navBtnStyle}>
          <DragHandleIcon sx={hamburgerIconStyle} />
        </Button>
      )}
      <SwipeableDrawer
        open={showNavBar}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}>
        {renderNavBarOptions()}
      </SwipeableDrawer>
    </Box>
  );
};

export default MobileNavBar;
